import 'bootstrap';
import '@heal/index.js';

window.addEventListener('hide.bs.modal', () => {
  if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
  }
});
